import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { MultiStepDragAndDrop } from '@atlassian/mpac-partners';
import { TextInput } from '@atlassian/mpac-ui';
import { WindowUtils } from '@atlassian/mpac-utils';

import HPBannerSlideConfig from '../HPBannerSlideConfig';

import type { HomePageBannerConfigType } from '@atlassian/mpac-types';

const flexStyles = xcss({ gap: 'space.200', flexDirection: 'column' });
const containerStyles = xcss({
  marginTop: 'space.400',
  gap: 'space.300',
  flexDirection: 'column',
});
const loopContainerStyles = xcss({
  gap: 'space.400',
  flexDirection: 'row',
  display: 'flex',
});

type Props = {
  defaultValue?: Partial<HomePageBannerConfigType>;
  name: string;
};

const HomePageBannerContainer = ({
  defaultValue = { tiles: [], runInLoop: false, loopDurationInSeconds: 0 },
  name,
}: Props) => {
  const tiles = (defaultValue.tiles || []).map((item, index) => ({
    ...item,
    id: WindowUtils.randomUUID(),
    isAccordianBoxOpen: index === 0,
  }));

  return (
    <Flex xcss={containerStyles} testId="home-page-banner-container">
      <h3>Home Page Banner Configuration</h3>
      <Flex xcss={flexStyles}>
        <h4>Loop Properties</h4>
        <Box xcss={loopContainerStyles}>
          <TextInput
            label="Loop Duration (seconds)"
            name={`${name}.loopDurationInSeconds`}
            type="number"
            defaultValue={String(defaultValue.loopDurationInSeconds ?? '')}
            placeholder="Enter loop duration (1-10 seconds)"
            validate={(value) => {
              if (value === null || value === undefined || value === '') {
                return;
              }
              const num = Number(value);
              if (Number.isNaN(num)) {
                return 'Please enter a valid number';
              }
              if (num < 1) {
                return 'Minimum allowed value is 1 second';
              }
              if (num > 10) {
                return 'Maximum allowed value is 10 seconds';
              }
            }}
            applyDefaultValidation
          />
          <CheckboxField name={`${name}.runInLoop`} defaultIsChecked={defaultValue.runInLoop}>
            {({ fieldProps }) => <Checkbox {...fieldProps} label="Run in loop?" />}
          </CheckboxField>
        </Box>

        <h4>Slides</h4>
        <MultiStepDragAndDrop
          label="Slide"
          name={`${name}.tiles`}
          value={tiles}
          content={HPBannerSlideConfig}
          addNewRecordLabel="Add New Slide"
        />
      </Flex>
    </Flex>
  );
};

export default HomePageBannerContainer;
